import React, { useEffect } from 'react'
import { setting, user } from '../../../utils/images/imagepath'
import { Link } from 'react-router-dom'
import { routes } from '../../../utils/routes'
import { useDispatch } from 'react-redux'
import { setAppTitle } from '../../../store/commonSlice'
import { useSelector } from 'react-redux'
import AccessDenied from '../../authentication/accessDenied'

const Settings = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setAppTitle('Settings'))
  }, [])

  const { info, isSuperAdmin } = useSelector((state: any) => state?.role)
  const roles: any = info || {}
  const isSAdmin: any = isSuperAdmin || false
  const system_definitions = isSAdmin || roles?.system_definitions
  const personal_settings = isSAdmin || roles?.personal_settings
  const sales_settings = isSAdmin || roles?.sales_settings
  const purchase_settings = isSAdmin || roles?.purchase_settings
  const settings =
    isSAdmin ||
    roles?.system_definitions ||
    roles?.personal_settings ||
    roles?.sales_settings ||
    roles?.purchase_settings

  return (
    <>
      <div className='page-header'>
        <div className='row'>
          <div className='col-sm-12'>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item'>Settings</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Companies Form */}
      {settings ? (
        <div className='setings-form'>
          <ul>
            {system_definitions && (
              <li>
                <Link to='/settings/company-profile'>
                  <img src={setting} alt='img' />
                  <span>System Definitions</span>
                </Link>
              </li>
            )}
            {personal_settings && (
              <li>
                <Link to={routes.personalsettingsAccount.path}>
                  <img src={user} alt='img' />
                  <span>Personal Settings</span>
                </Link>
              </li>
            )}
            {sales_settings && (
              <li>
                <Link to={routes.salesSettings.path}>
                  <img src={user} alt='img' />
                  <span>Sales Settings</span>
                </Link>
              </li>
            )}
            {purchase_settings && (
              <li>
                <Link to={routes.purchaseSettings.path}>
                  <img src={user} alt='img' />
                  <span>Purchase Settings</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      ) : (
        <AccessDenied />
      )}
      {/* /Companies Form */}
    </>
  )
}

export default Settings
